import React, { useEffect, useState } from "react";
import { Row, Col, Form, Image, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Card from "../Card";
import axios from "axios";
import imgsuccess from "../../assets/images/pages/img-success.png";
import Select from "react-select";
import "../../assets/css/stepper.css";
import { getUserList } from "../../services/Users-services";
import {
  addRegion,
  getRegionDetails,
  updateRegion,
} from "../../services/Organization-services";
import {
  callToast,
  showErrorMessages,
} from "../../services/utilityFunctions.js";
import {
  getCountryList,
  getCityList,
  getStateList,
} from "../../services/system.js";
import { useGlobalState } from "../../services/hostelConst";
import { getLocalStorageData } from "../../services/axiosComponent";
import { getProfileDetails } from "../../services/authentication";
import { selectStyle } from "../../services/constant";
const AddRegionForm = ({ navigate, refresh }) => {
  const { closeModal, modalState } = useGlobalState();

  const [step, setStep] = useState(1);

  const prepareFormData = (data = null) => {
    return {
      // Site Info
      name: data == null ? "" : data.NAME,
      description: data == null ? "" : data.DESCRIPTION,
      managerId: {
        value: data == null ? "" : data._MANAGER,
        label: data == null ? "" : data.MANAGER,
      },
    };
  };
  const [formData, setFormData] = useState(prepareFormData(modalState.data));

  const [loadingManagerOptions, setLoadingManagerOptions] = useState(false);

  const [managerOptions, setManagerOptions] = useState([]);

  const [managerName, setManagerName] = useState("");

  const [loading, setLoading] = useState(false);

  const [errors, setErrors] = useState({});

  const getManagerOptions = async () => {
    setLoadingManagerOptions(true);
    const res = await getUserList({
      query: managerName,

      status: "Y",
    });
    if (res != "fail") {
      console.log("called");
      var list = [];
      res.data.entityList.map((item) => {
        list.push({
          value: item._ID,
          label: item["NAME"],
        });
      });
      setManagerOptions(list);
    } else {
      showErrorMessages({ data: res, navigate });
    }
    setLoadingManagerOptions(false);
  };
  useEffect(() => {
    getManagerOptions();

    return () => {};
  }, []);

  const handleChange = (field, value) => {
    setFormData({ ...formData, [field]: value });

    setErrors({ ...errors, [field]: "" });
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Name is required";
    }
    if (!formData.description.trim()) {
      // console.log("Description is required");
      newErrors.description = "Description is required";
    }
    if (!formData.managerId || !formData.managerId.value) {
      newErrors.managerId = "Manager is required";
    }

    // Step 2 validation

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);
      var dataToSubmit = {
        description: formData.description,
        managerId: formData.managerId.value,
        name: formData.name,
        organizationId:
          getLocalStorageData("profileDetails")["_ORGANIZATION_"]._ID,
        id: modalState.isEditing ? modalState.data._ID : null,
      };

      var res = modalState.isEditing
        ? await updateRegion(dataToSubmit)
        : await addRegion(dataToSubmit);
      if (res.status == "success") {
        callToast(
          "success",
          "Success",
          modalState.isEditing
            ? "Region Updated Succesfully"
            : "Region Added Successfully"
        );
        await refresh({ columnRefresh: false, isLoading: false });
        closeModal();
      } else {
        showErrorMessages({ data: res, navigate });
      }
      setLoading(false);
    }
  };
  const handleNextStep = () => {
    if (validateForm()) {
      setStep(step + 1);
    }
  };

  const [isRegionSearchable, setIsRegionSearchable] = useState(true);
  const [regionOptions, setRegionOptions] = useState([]);
  // const getRegionList = async () => {
  //   var data = await JSON.parse(localStorage.getItem("profileDetails"))
  //     .response;

  //   var list = JSON.parse(localStorage.getItem("regionList"));
  //   if (
  //     list.length == 1 &&
  //     list[0].value == data["_REGION"] &&
  //     data["_REGION_ACCESS_"] == null
  //   ) {
  //     handleChange("regionId", {
  //       value: list[0].value,
  //       label: list[0].label,
  //     });
  //     setIsRegionSearchable(false);
  //   }
  //   setRegionOptions(list);
  // };

  return (
    <>
      <div
        id="myToastButton"
        class="pixel-corners"
        style={{ display: "block" }}
      ></div>
      <section className="">
        <div className="d-flex  justify-content-center ">
          <div className="w-100 m-3">
            {/* <div
              className="position-absolute top-10 start-20 bg-primary"
              style={{
                left: "5%",
                top: "-10%",
                width: "12%",
                height: "110%",
                backgroundColor: "blue",
              }}
            ></div> */}

            <div className="d-flex h-100">
              <div className="w-100">
                {/* <div className="d-flex justify-content-start">
                  <strong className="text-primary" style={{ fontSize: "2rem" }}>
                    Sites
                  </strong>
                </div> */}

                <>
                  <div className="stepper mb-3 ">
                    <div className="d-flex justify-content-between">
                      <div className={`step active`}>Region Info</div>
                    </div>
                  </div>

                  {
                    // Step 1: Site Info
                    <>
                      <div className="mb-3 m-4">
                        <label className="form-label">Name</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Region Name"
                          value={formData.name}
                          onChange={(e) => handleChange("name", e.target.value)}
                        />
                        {errors.name && (
                          <small className="text-danger">{errors.name}</small>
                        )}
                      </div>

                      <div className="mb-3 m-4">
                        <label className="form-label">Description</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Description"
                          value={formData.description}
                          onChange={(e) =>
                            handleChange("description", e.target.value)
                          }
                        />
                        {errors.description && (
                          <small className="text-danger">
                            {errors.description}
                          </small>
                        )}
                      </div>

                      <div className="row mb-3 m-4 me-2 ms-2">
                        <div className="col-md-12">
                          <label className="form-label">Manager</label>
                          <Select
                            style={selectStyle}
                            options={managerOptions}
                            value={
                              formData.managerId.label === ""
                                ? null
                                : formData.managerId
                            }
                            onChange={(value) =>
                              handleChange(
                                "managerId",
                                value == null ? { value: "", label: "" } : value
                              )
                            }
                            styles={{
                              menu: (provided) => ({
                                ...provided,
                                height: "100px", // Set dropdown height
                              }),
                              menuList: (provided) => ({
                                ...provided,
                                maxHeight: "100px", // Set max height for the list
                                overflowY: "auto",
                              }),
                            }}
                            placeholder="Select Manager"
                            isSearchable
                            onInputChange={(inputValue) => {
                              if (inputValue.length > 0) {
                                setManagerName(inputValue);
                                getManagerOptions();
                              }
                            }}
                            noOptionsMessage={() => {
                              return "No Manager Found";
                            }}
                            components={
                              loadingManagerOptions
                                ? {
                                    DropdownIndicator,
                                  }
                                : null
                            }
                            className="basic-single"
                            classNamePrefix="select"
                            filterOption={(option, inputValue) =>
                              option.label
                                .toLowerCase()
                                .includes(inputValue.toLowerCase())
                            }
                          />
                          {errors.managerId && (
                            <small className="text-danger">
                              {errors.managerId}
                            </small>
                          )}
                        </div>
                      </div>

                      <div className="d-flex justify-content-end m-3 mb-0">
                        <Button
                          type="submit"
                          disabled={loading}
                          onClick={handleSubmit}
                        >
                          {loading ? (
                            <div
                              class="spinner-border text-light"
                              role="status"
                            >
                       
                            </div>
                          ) : (
                            "Submit"
                          )}
                        </Button>
                      </div>
                    </>
                  }
                </>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
const DropdownIndicator = (props) => {
  return (
    <div {...props.innerProps}>
      <div
        class="spinner-border text-primary spinner-border-sm m-2"
        role="status"
      >
 
      </div>
    </div>
  );
};

export default AddRegionForm;
